import React from 'react'

import styles from './styles.module.scss'

import type { LogTitleProps } from './types'

export const LogTitle: React.FC<LogTitleProps> = ({ log }) => {
  const { title, dateTime } = log

  return (
    <div className={ styles.log }>
      <span className={ styles.log__title }>{ title }</span>
      <span className={ styles.log__dateTime }>{ dateTime }</span>
    </div>
  )
}
